import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class BuyAnim {
  constructor(section) {
    this.section = section;
		this.title = this.section.querySelector(".section-title");
		this.buyBtn = this.section.querySelector(".fp-btn-ter");	
		this.text = this.section.querySelector(".more-info");
		this.posterImg = this.section.querySelector(".poster-wrap");
		
		this.init();
  }

  init() {
		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });
			this.textSplit = SplitText.create(this.text, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			this.tl = gsap.timeline({ 
				scrollTrigger: {
					trigger: this.section,
					start: "top 60%",
					once: true,
				},
				defaults: {ease: "expo.out", force3D: true},
				onComplete: () => {
					this.titleSplit.revert();
					this.textSplit.revert();
				}
			});

			this.tl
				.set([this.title, this.text], {autoAlpha: 1}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 1.5, stagger: 0.1 }, 0)
				.to([this.buyBtn], {autoAlpha: 1, duration: 1.5 }, "<10%")
				.from(this.textSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.4, stagger: 0.1 }, "<5%")
				.to(this.posterImg, {autoAlpha: 1, duration: 1.2, ease: "power3.inOut"}, "<");
		});

		return this.tl;
  }
}